<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="90"
    height="71"
    viewBox="0 0 90 71"
    fill="none"
  >
    <path
      d="M57.9176 35.9385C59.9559 35.9385 61.6083 34.2816 61.6083 32.2378C61.6083 30.194 59.9559 28.5372 57.9176 28.5372C55.8792 28.5372 54.2268 30.194 54.2268 32.2378C54.2268 34.2816 55.8792 35.9385 57.9176 35.9385Z"
    />
    <path
      d="M45.0001 35.9385C47.0384 35.9385 48.6908 34.2816 48.6908 32.2378C48.6908 30.194 47.0384 28.5372 45.0001 28.5372C42.9617 28.5372 41.3094 30.194 41.3094 32.2378C41.3094 34.2816 42.9617 35.9385 45.0001 35.9385Z"
    />
    <path
      d="M70.8351 35.9385C72.8734 35.9385 74.5258 34.2816 74.5258 32.2378C74.5258 30.194 72.8734 28.5372 70.8351 28.5372C68.7967 28.5372 67.1443 30.194 67.1443 32.2378C67.1443 34.2816 68.7967 35.9385 70.8351 35.9385Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26.7047 32.2378C26.7047 14.9429 40.6752 0.938477 57.9176 0.938477C75.1599 0.938477 89.1304 14.9429 89.1304 32.2378C89.1304 37.2606 87.9306 42.0148 85.8242 46.2224L89.0927 61.4867C89.2267 62.1126 88.9981 62.7608 88.5016 63.1624C88.0052 63.5639 87.3258 63.6502 86.7454 63.3855L75.3303 58.1781C70.3574 61.5489 64.3739 63.5372 57.9176 63.5372C40.6752 63.5372 26.7047 49.5328 26.7047 32.2378ZM57.9176 4.32701C42.534 4.32701 30.079 16.8191 30.079 32.2378C30.079 47.6565 42.534 60.1486 57.9176 60.1486C63.9873 60.1486 69.5868 58.1796 74.1661 54.8624C74.657 54.5068 75.2999 54.4425 75.851 54.6939L85.0891 58.9081L82.3983 46.3419C82.315 45.9528 82.3707 45.5467 82.5557 45.1948C84.5915 41.3218 85.7561 36.9109 85.7561 32.2378C85.7561 16.8191 73.3011 4.32701 57.9176 4.32701Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M25.5882 17.5326C25.7483 18.4544 25.1341 19.332 24.2161 19.4929C12.8643 21.4822 4.24405 31.3946 4.24405 43.3397C4.24405 47.4004 5.26019 51.2199 7.02076 54.5774C7.20511 54.929 7.26055 55.3345 7.17738 55.7229L4.91061 66.3108L12.618 62.798C13.1687 62.5471 13.8111 62.6112 14.3017 62.9663C18.2727 65.84 23.1343 67.5499 28.3919 67.5499C32.9837 67.5499 37.2591 66.27 40.8966 64.0574C41.6936 63.5726 42.731 63.8284 43.2138 64.6288C43.6965 65.4291 43.4418 66.4709 42.6448 66.9557C38.4949 69.4799 33.6173 70.9384 28.3919 70.9384C22.7473 70.9384 17.5037 69.2088 13.1405 66.2811L3.25416 70.787C2.6738 71.0515 1.99455 70.965 1.49827 70.5635C1.002 70.1619 0.773413 69.5138 0.907373 68.8881L3.75193 55.6014C1.9221 51.9148 0.869683 47.7527 0.869683 43.3397C0.869683 29.7134 10.7029 18.4212 23.636 16.1548C24.554 15.9939 25.428 16.6108 25.5882 17.5326Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'TextBubbleComponent',
}
</script>

<style scoped lang="scss">
@import 'app/styles/component_variables.scss';

svg {
    fill: var(--color-dark-grey);
}
</style>